// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown_default__TKQ12, .dropdown_button__JP-tB,
.dropdown_outlined__F7B4n,
.dropdown_secondary__JQuKU,
.dropdown_destructive__csig7,
.dropdown_approve__WqLF6,
.dropdown_link__6pQQq,
.dropdown_disabled__bDVO1 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  text-transform: capitalize;
  background-color: var(--brand);
  border-radius: var(--border-radius);
  padding: 8px 16px;
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--white);
  border: 1px solid transparent;
  letter-spacing: 0.3px;
  line-height: 1.3;
  transition: all 0.2s ease-in-out;
  text-align: center;
}
.dropdown_default__TKQ12 img, .dropdown_button__JP-tB img,
.dropdown_default__TKQ12 svg,
.dropdown_button__JP-tB svg,
.dropdown_outlined__F7B4n img,
.dropdown_outlined__F7B4n svg,
.dropdown_secondary__JQuKU img,
.dropdown_secondary__JQuKU svg,
.dropdown_destructive__csig7 img,
.dropdown_destructive__csig7 svg,
.dropdown_approve__WqLF6 img,
.dropdown_approve__WqLF6 svg,
.dropdown_link__6pQQq img,
.dropdown_link__6pQQq svg,
.dropdown_disabled__bDVO1 img,
.dropdown_disabled__bDVO1 svg {
  width: 18px;
  height: 18px;
}
.dropdown_default__TKQ12.dropdown_sm__aqCsB, .dropdown_sm__aqCsB.dropdown_button__JP-tB,
.dropdown_outlined__F7B4n.dropdown_sm__aqCsB,
.dropdown_secondary__JQuKU.dropdown_sm__aqCsB,
.dropdown_destructive__csig7.dropdown_sm__aqCsB,
.dropdown_approve__WqLF6.dropdown_sm__aqCsB,
.dropdown_link__6pQQq.dropdown_sm__aqCsB,
.dropdown_disabled__bDVO1.dropdown_sm__aqCsB {
  font: var(--body-font-four);
  padding: 7px 12px;
}
.dropdown_default__TKQ12.dropdown_lg__dkMGS, .dropdown_lg__dkMGS.dropdown_button__JP-tB,
.dropdown_outlined__F7B4n.dropdown_lg__dkMGS,
.dropdown_secondary__JQuKU.dropdown_lg__dkMGS,
.dropdown_destructive__csig7.dropdown_lg__dkMGS,
.dropdown_approve__WqLF6.dropdown_lg__dkMGS,
.dropdown_link__6pQQq.dropdown_lg__dkMGS,
.dropdown_disabled__bDVO1.dropdown_lg__dkMGS {
  min-height: 40px;
  padding: 10px 16px;
}
.dropdown_default__TKQ12:active, .dropdown_button__JP-tB:active, .dropdown_default__TKQ12:hover, .dropdown_button__JP-tB:hover,
.dropdown_outlined__F7B4n:active,
.dropdown_outlined__F7B4n:hover,
.dropdown_secondary__JQuKU:active,
.dropdown_secondary__JQuKU:hover,
.dropdown_destructive__csig7:active,
.dropdown_destructive__csig7:hover,
.dropdown_approve__WqLF6:active,
.dropdown_approve__WqLF6:hover,
.dropdown_link__6pQQq:active,
.dropdown_link__6pQQq:hover,
.dropdown_disabled__bDVO1:active,
.dropdown_disabled__bDVO1:hover {
  box-shadow: var(--shadowxsoffset-x) var(--shadowxsoffset-y) var(--shadowxsblur-radius) var(--shadowxsspread-radius) rgba(49, 49, 49, 0.0509803922);
  background-color: #96b8ca;
}
.dropdown_default__TKQ12:focus, .dropdown_button__JP-tB:focus,
.dropdown_outlined__F7B4n:focus,
.dropdown_secondary__JQuKU:focus,
.dropdown_destructive__csig7:focus,
.dropdown_approve__WqLF6:focus,
.dropdown_link__6pQQq:focus,
.dropdown_disabled__bDVO1:focus {
  box-shadow: 0px 0px 0px 3px #d6e3eb;
}
.dropdown_default__TKQ12:disabled, .dropdown_button__JP-tB:disabled,
.dropdown_outlined__F7B4n:disabled,
.dropdown_secondary__JQuKU:disabled,
.dropdown_destructive__csig7:disabled,
.dropdown_approve__WqLF6:disabled,
.dropdown_link__6pQQq:disabled,
.dropdown_disabled__bDVO1:disabled {
  cursor: not-allowed;
  background-color: var(--secondary-Text);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  opacity: 0.5;
}

.dropdown_secondary__JQuKU {
  background-color: #f2f6f8;
  color: var(--primary-Text);
}
.dropdown_secondary__JQuKU:hover {
  background-color: #e9edf0;
}
.dropdown_secondary__JQuKU:focus {
  box-shadow: 0px 0px 0px 3px #d6e3eb;
}
.dropdown_secondary__JQuKU:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f2f6f8;
}

.dropdown_destructive__csig7 {
  background-color: var(--error);
  color: var(--white);
}
.dropdown_destructive__csig7:hover {
  background-color: #f6695e;
}
.dropdown_destructive__csig7:focus {
  box-shadow: 0px 0px 0px 3px #fcc5c1;
}
.dropdown_destructive__csig7:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: var(--error);
}

.dropdown_outlined__F7B4n {
  background-color: var(--white);
  color: var(--primary-Text);
  border: 1px solid var(--border);
  box-shadow: 0px 0px 0px 3px rgba(197, 196, 196, 0.0509803922);
}
.dropdown_outlined__F7B4n:hover {
  background-color: #f2f6f8;
}
.dropdown_outlined__F7B4n:focus {
  box-shadow: 0px 0px 0px 3px #d6e3eb;
}
.dropdown_outlined__F7B4n:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: var(--white);
}
.dropdown_outlined__F7B4n.dropdown_active__pg2Ig {
  background-color: var(--brand);
  color: var(--white);
  border-color: var(--brand);
}
.dropdown_outlined__F7B4n.dropdown_active__pg2Ig img,
.dropdown_outlined__F7B4n.dropdown_active__pg2Ig svg {
  filter: brightness(0) invert(1);
}
.dropdown_outlined__F7B4n.dropdown_active__pg2Ig:hover {
  background-color: #96b8ca;
}

.dropdown_approve__WqLF6 {
  background-color: var(--success);
  color: var(--white);
}
.dropdown_approve__WqLF6:hover {
  background-color: #83c085;
}
.dropdown_approve__WqLF6:focus {
  box-shadow: 0px 0px 0px 3px rgba(197, 196, 196, 0.0509803922);
}
.dropdown_approve__WqLF6:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: var(--success);
}

.dropdown_link__6pQQq {
  background-color: transparent;
  border: unset;
  color: var(--primary-Text);
  box-shadow: unset;
}
.dropdown_link__6pQQq:hover {
  background-color: transparent;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.dropdown_link__6pQQq:focus {
  box-shadow: 0px 0px 0px 3px #d6e3eb;
}
.dropdown_link__6pQQq:disabled {
  cursor: not-allowed;
  background-color: transparent;
  opacity: 0.5;
  box-shadow: unset;
  text-decoration: unset;
}

.dropdown_pilled__LjE-r {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 16px;
  font: var(--body-font-three);
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 1.3;
  background-color: var(--white);
  color: var(--brand);
  border: 1px solid #e8ebee;
  border-radius: 20px;
  min-height: 40px;
  text-transform: capitalize;
  width: 100%;
}
.dropdown_pilled__LjE-r:hover, .dropdown_pilled__LjE-r:focus, .dropdown_pilled__LjE-r:active {
  background-color: var(--brand);
  color: var(--white);
}
.dropdown_pilled__LjE-r:hover img,
.dropdown_pilled__LjE-r:hover svg, .dropdown_pilled__LjE-r:focus img,
.dropdown_pilled__LjE-r:focus svg, .dropdown_pilled__LjE-r:active img,
.dropdown_pilled__LjE-r:active svg {
  filter: brightness(0) invert(1);
}

@media (max-width: 991px) {
  .dropdown_default__TKQ12, .dropdown_button__JP-tB,
  .dropdown_contained__gWR4v,
  .dropdown_secondary__JQuKU,
  .dropdown_outlined__F7B4n,
  .dropdown_approve__WqLF6 {
    font-size: 12px;
    padding: 7px 10px;
  }
}
.dropdown_wrapper__qi9Vk {
  position: relative;
  display: inline-block;
}

.dropdown_button__JP-tB {
  display: flex;
  align-items: stretch;
  gap: 0;
  background-color: var(--brand);
  height: 100%;
  overflow: hidden;
}
.dropdown_button__JP-tB:hover {
  background-color: var(--brand);
}
.dropdown_button__JP-tB:focus-visible, .dropdown_button__JP-tB:focus {
  outline: none;
  box-shadow: none;
}
.dropdown_button__JP-tB span {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}
.dropdown_button__JP-tB.dropdown_sm__aqCsB {
  font: var(--body-font-four);
  padding: 0;
}
.dropdown_button__JP-tB.dropdown_md__yEyhW {
  font: var(--body-font-three);
  padding: 0;
}
.dropdown_button__JP-tB.dropdown_lg__dkMGS {
  min-height: 44px;
  padding: 0;
}

.dropdown_chevron__RyR-u {
  margin-left: auto;
  font-size: 18px;
  background-color: #7197ac;
  height: auto !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  flex: 0 0 auto;
}

.dropdown_menu__5yVkp {
  position: absolute;
  background-color: var(--white);
  border-radius: var(--border-radius);
  min-width: max-content;
  max-width: 280px;
  box-shadow: var(--shadow-md);
  z-index: 20;
  border: 1px solid var(--border);
}
.dropdown_menu__5yVkp button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 12px;
  background: none;
  border: none;
  text-align: left;
  font: var(--body-font-three);
  cursor: pointer;
  color: var(--primary-Text);
  transition: background-color 0.2s ease;
  border-radius: 0;
}
.dropdown_menu__5yVkp button:hover {
  background-color: var(--bg1);
}
.dropdown_menu__5yVkp button img {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.dropdown_menu__5yVkp button span {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown_menu__5yVkp .dropdown_divider__Vn\\+OZ {
  margin: 0px 0;
  height: 1px;
  background: var(--border);
}

.dropdown_bottom-left__8n372 {
  top: 110%;
  left: 0;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
}

.dropdown_bottom-right__zm3wy {
  top: 110%;
  right: 0;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
}

.dropdown_top-left__EkbE0 {
  bottom: 110%;
  left: 0;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
}

.dropdown_top-right__Civ-F {
  bottom: 110%;
  right: 0;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
}

/* reuse variants */`, "",{"version":3,"sources":["webpack://./src/components/atoms/button/btnStyle.module.scss","webpack://./src/components/atoms/dropdown/dropdown.module.scss"],"names":[],"mappings":"AACA;;;;;;;EAOC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,0BAAA;EACA,8BAAA;EACA,mCAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;ACAD;ADEC;;;;;;;;;;;;;;;EAEC,WAAA;EACA,YAAA;ACaF;ADVC;;;;;;;EACC,2BAAA;EACA,iBAAA;ACkBF;ADfC;;;;;;;EACC,gBAAA;EACA,kBAAA;ACuBF;ADpBC;;;;;;;;;;;;;EAEC,kJAAA;EACA,yBAAA;ACiCF;AD9BC;;;;;;;EACC,mCAAA;ACsCF;ADnCC;;;;;;;EACC,mBAAA;EACA,uCAAA;EACA,+CAAA;EACA,YAAA;AC2CF;;ADtCA;EACC,yBAAA;EACA,0BAAA;ACyCD;ADvCC;EACC,yBAAA;ACyCF;ADtCC;EACC,mCAAA;ACwCF;ADrCC;EACC,mBAAA;EACA,YAAA;EACA,yBAAA;ACuCF;;ADlCA;EACC,8BAAA;EACA,mBAAA;ACqCD;ADnCC;EACC,yBAAA;ACqCF;ADlCC;EACC,mCAAA;ACoCF;ADjCC;EACC,mBAAA;EACA,YAAA;EACA,8BAAA;ACmCF;;AD9BA;EACC,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,6DAAA;ACiCD;AD/BC;EACC,yBAAA;ACiCF;AD9BC;EACC,mCAAA;ACgCF;AD7BC;EACC,mBAAA;EACA,YAAA;EACA,8BAAA;AC+BF;AD5BC;EACC,8BAAA;EACA,mBAAA;EACA,0BAAA;AC8BF;AD5BE;;EAEC,+BAAA;AC8BH;AD3BE;EACC,yBAAA;AC6BH;;ADvBA;EACC,gCAAA;EACA,mBAAA;AC0BD;ADxBC;EACC,yBAAA;AC0BF;ADvBC;EACC,6DAAA;ACyBF;ADtBC;EACC,mBAAA;EACA,YAAA;EACA,gCAAA;ACwBF;;ADnBA;EACC,6BAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;ACsBD;ADpBC;EACC,6BAAA;EACA,0BAAA;EACA,0BAAA;ACsBF;ADnBC;EACC,mCAAA;ACqBF;ADlBC;EACC,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;ACoBF;;ADhBA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;ACmBD;ADjBC;EAIC,8BAAA;EACA,mBAAA;ACgBF;ADdE;;;;EAEC,+BAAA;ACkBH;;ADbA;EAEC;;;;;IAKC,eAAA;IACA,iBAAA;ECeA;AACF;AA9OA;EACC,kBAAA;EACA,qBAAA;AAgPD;;AA7OA;EAEC,aAAA;EACA,oBAAA;EACA,MAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;AA+OD;AA7OC;EACC,8BAAA;AA+OF;AA5OC;EAEC,aAAA;EACA,gBAAA;AA6OF;AA1OC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA4OF;AAzOC;EACC,2BAAA;EAEA,UAAA;AA0OF;AAvOC;EACC,4BAAA;EAEA,UAAA;AAwOF;AArOC;EACC,gBAAA;EAEA,UAAA;AAsOF;;AAlOA;EACC,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAqOD;;AAlOA;EACC,kBAAA;EACA,8BAAA;EACA,mCAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EAEA,WAAA;EACA,+BAAA;AAoOD;AAlOC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,0BAAA;EACA,sCAAA;EACA,gBAAA;AAoOF;AAlOE;EACC,4BAAA;AAoOH;AAjOE;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAmOH;AAhOE;EACC,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkOH;AA9NC;EACC,aAAA;EACA,WAAA;EACA,yBAAA;AAgOF;;AA5NA;EACC,SAAA;EACA,OAAA;EACA,uDAAA;AA+ND;;AA5NA;EACC,SAAA;EACA,QAAA;EACA,uDAAA;AA+ND;;AA5NA;EACC,YAAA;EACA,OAAA;EACA,uDAAA;AA+ND;;AA5NA;EACC,YAAA;EACA,QAAA;EACA,uDAAA;AA+ND;;AA5NA,mBAAA","sourcesContent":["// Contained variant button\r\n.default,\r\n.outlined,\r\n.secondary,\r\n.destructive,\r\n.approve,\r\n.link,\r\n.disabled {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tcursor: pointer;\r\n\ttext-transform: capitalize;\r\n\tbackground-color: var(--brand);\r\n\tborder-radius: var(--border-radius);\r\n\tpadding: 8px 16px;\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 500;\r\n\tcolor: var(--white);\r\n\tborder: 1px solid transparent;\r\n\tletter-spacing: 0.3px;\r\n\tline-height: 1.3;\r\n\ttransition: all 0.2s ease-in-out;\r\n\ttext-align: center;\r\n\r\n\timg,\r\n\tsvg {\r\n\t\twidth: 18px;\r\n\t\theight: 18px;\r\n\t}\r\n\r\n\t&.sm {\r\n\t\tfont: var(--body-font-four);\r\n\t\tpadding: 7px 12px;\r\n\t}\r\n\r\n\t&.lg {\r\n\t\tmin-height: 40px;\r\n\t\tpadding: 10px 16px;\r\n\t}\r\n\r\n\t&:active,\r\n\t&:hover {\r\n\t\tbox-shadow: var(--shadowxsoffset-x) var(--shadowxsoffset-y) var(--shadowxsblur-radius) var(--shadowxsspread-radius) #3131310d;\r\n\t\tbackground-color: #96b8ca;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #d6e3eb;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\tbackground-color: var(--secondary-Text);\r\n\t\tbox-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);\r\n\t\topacity: 0.5;\r\n\t}\r\n}\r\n\r\n// secondary variant button\r\n.secondary {\r\n\tbackground-color: #f2f6f8;\r\n\tcolor: var(--primary-Text);\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #e9edf0;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #d6e3eb;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\topacity: 0.5;\r\n\t\tbackground-color: #f2f6f8;\r\n\t}\r\n}\r\n\r\n// destructive variant button\r\n.destructive {\r\n\tbackground-color: var(--error);\r\n\tcolor: var(--white);\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #f6695e;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #fcc5c1;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\topacity: 0.5;\r\n\t\tbackground-color: var(--error);\r\n\t}\r\n}\r\n\r\n// Outlined variant button\r\n.outlined {\r\n\tbackground-color: var(--white);\r\n\tcolor: var(--primary-Text);\r\n\tborder: 1px solid var(--border);\r\n\tbox-shadow: 0px 0px 0px 3px #c5c4c40d;\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #f2f6f8;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #d6e3eb;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\topacity: 0.5;\r\n\t\tbackground-color: var(--white);\r\n\t}\r\n\r\n\t&.active {\r\n\t\tbackground-color: var(--brand);\r\n\t\tcolor: var(--white);\r\n\t\tborder-color: var(--brand);\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\tfilter: brightness(0) invert(1);\r\n\t\t}\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground-color: #96b8ca;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// approve variant button\r\n.approve {\r\n\tbackground-color: var(--success);\r\n\tcolor: var(--white);\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #83c085;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #c5c4c40d;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\topacity: 0.5;\r\n\t\tbackground-color: var(--success);\r\n\t}\r\n}\r\n\r\n// Link variant button\r\n.link {\r\n\tbackground-color: transparent;\r\n\tborder: unset;\r\n\tcolor: var(--primary-Text);\r\n\tbox-shadow: unset;\r\n\r\n\t&:hover {\r\n\t\tbackground-color: transparent;\r\n\t\ttext-decoration: underline;\r\n\t\ttext-underline-offset: 2px;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #d6e3eb;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\tbackground-color: transparent;\r\n\t\topacity: 0.5;\r\n\t\tbox-shadow: unset;\r\n\t\ttext-decoration: unset;\r\n\t}\r\n}\r\n\r\n.pilled {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tcursor: pointer;\r\n\tpadding: 8px 16px;\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 500;\r\n\tletter-spacing: 0.3px;\r\n\tline-height: 1.3;\r\n\tbackground-color: var(--white);\r\n\tcolor: var(--brand);\r\n\tborder: 1px solid #e8ebee;\r\n\tborder-radius: 20px;\r\n\tmin-height: 40px;\r\n\ttext-transform: capitalize;\r\n\twidth: 100%;\r\n\r\n\t&:hover,\r\n\t&:focus,\r\n\t&:active,\r\n\t&:active {\r\n\t\tbackground-color: var(--brand);\r\n\t\tcolor: var(--white);\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\tfilter: brightness(0) invert(1);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\r\n\t.default,\r\n\t.contained,\r\n\t.secondary,\r\n\t.outlined,\r\n\t.approve {\r\n\t\tfont-size: 12px;\r\n\t\tpadding: 7px 10px;\r\n\t}\r\n}","@import '../button/btnStyle.module.scss';\r\n\r\n.wrapper {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.button {\r\n\t@extend .default;\r\n\tdisplay: flex;\r\n\talign-items: stretch;\r\n\tgap: 0;\r\n\tbackground-color: var(--brand);\r\n\theight: 100%;\r\n\toverflow: hidden;\r\n\r\n\t&:hover {\r\n\t\tbackground-color: var(--brand);\r\n\t}\r\n\r\n\t&:focus-visible,\r\n\t&:focus {\r\n\t\toutline: none;\r\n\t\tbox-shadow: none;\r\n\t}\r\n\r\n\tspan {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tpadding: 0 20px;\r\n\t}\r\n\r\n\t&.sm {\r\n\t\tfont: var(--body-font-four);\r\n\t\t// padding: 6px 12px;\r\n\t\tpadding: 0;\r\n\t}\r\n\r\n\t&.md {\r\n\t\tfont: var(--body-font-three);\r\n\t\t// padding: 8px 16px;\r\n\t\tpadding: 0;\r\n\t}\r\n\r\n\t&.lg {\r\n\t\tmin-height: 44px;\r\n\t\t// padding: 12px 20px;\r\n\t\tpadding: 0;\r\n\t}\r\n}\r\n\r\n.chevron {\r\n\tmargin-left: auto;\r\n\tfont-size: 18px;\r\n\tbackground-color: #7197ac;\r\n\theight: auto !important;\r\n\tdisplay: flex !important;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tpadding: 0 10px;\r\n\tflex: 0 0 auto;\r\n}\r\n\r\n.menu {\r\n\tposition: absolute;\r\n\tbackground-color: var(--white);\r\n\tborder-radius: var(--border-radius);\r\n\tmin-width: max-content;\r\n\tmax-width: 280px;\r\n\tbox-shadow: var(--shadow-md);\r\n\t// padding: 2px 0;\r\n\tz-index: 20;\r\n\tborder: 1px solid var(--border);\r\n\r\n\tbutton {\r\n\t\twidth: 100%;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t\tpadding: 12px 12px;\r\n\t\tbackground: none;\r\n\t\tborder: none;\r\n\t\ttext-align: left;\r\n\t\tfont: var(--body-font-three);\r\n\t\tcursor: pointer;\r\n\t\tcolor: var(--primary-Text);\r\n\t\ttransition: background-color 0.2s ease;\r\n\t\tborder-radius: 0;\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground-color: var(--bg1);\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\tflex-shrink: 0;\r\n\t\t\twidth: 20px;\r\n\t\t\theight: 20px;\r\n\t\t\tobject-fit: contain;\r\n\t\t}\r\n\r\n\t\tspan {\r\n\t\t\tflex: 1;\r\n\t\t\tmin-width: 0;\r\n\t\t\toverflow: hidden;\r\n\t\t\ttext-overflow: ellipsis;\r\n\t\t\twhite-space: nowrap;\r\n\t\t}\r\n\t}\r\n\r\n\t.divider {\r\n\t\tmargin: 0px 0;\r\n\t\theight: 1px;\r\n\t\tbackground: var(--border);\r\n\t}\r\n}\r\n\r\n.bottom-left {\r\n\ttop: 110%;\r\n\tleft: 0;\r\n\tbox-shadow: 0px 0px 4px 0px #00000040;\r\n}\r\n\r\n.bottom-right {\r\n\ttop: 110%;\r\n\tright: 0;\r\n\tbox-shadow: 0px 0px 4px 0px #00000040;\r\n}\r\n\r\n.top-left {\r\n\tbottom: 110%;\r\n\tleft: 0;\r\n\tbox-shadow: 0px 0px 4px 0px #00000040;\r\n}\r\n\r\n.top-right {\r\n\tbottom: 110%;\r\n\tright: 0;\r\n\tbox-shadow: 0px 0px 4px 0px #00000040;\r\n}\r\n\r\n/* reuse variants */\r\n.default {\r\n\t@extend .default;\r\n}\r\n\r\n.secondary {\r\n\t@extend .secondary;\r\n}\r\n\r\n.outlined {\r\n\t@extend .outlined;\r\n}\r\n\r\n.destructive {\r\n\t@extend .destructive;\r\n}\r\n\r\n.link {\r\n\t@extend .link;\r\n}\r\n\r\n.pilled {\r\n\t@extend .pilled;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"default": `dropdown_default__TKQ12`,
	"button": `dropdown_button__JP-tB`,
	"outlined": `dropdown_outlined__F7B4n`,
	"secondary": `dropdown_secondary__JQuKU`,
	"destructive": `dropdown_destructive__csig7`,
	"approve": `dropdown_approve__WqLF6`,
	"link": `dropdown_link__6pQQq`,
	"disabled": `dropdown_disabled__bDVO1`,
	"sm": `dropdown_sm__aqCsB`,
	"lg": `dropdown_lg__dkMGS`,
	"active": `dropdown_active__pg2Ig`,
	"pilled": `dropdown_pilled__LjE-r`,
	"contained": `dropdown_contained__gWR4v`,
	"wrapper": `dropdown_wrapper__qi9Vk`,
	"md": `dropdown_md__yEyhW`,
	"chevron": `dropdown_chevron__RyR-u`,
	"menu": `dropdown_menu__5yVkp`,
	"divider": `dropdown_divider__Vn+OZ`,
	"bottom-left": `dropdown_bottom-left__8n372`,
	"bottom-right": `dropdown_bottom-right__zm3wy`,
	"top-left": `dropdown_top-left__EkbE0`,
	"top-right": `dropdown_top-right__Civ-F`
};
export default ___CSS_LOADER_EXPORT___;
